import { Badge } from "react-bootstrap";
import dayjs from "dayjs";
import "dayjs/locale/fr";

export default function FilterBadgeEnt({ selectedEle, setSelectedEle, type }) {
    return (<>
        {
            selectedEle.map((ele) => (
                <Badge
                    key={ele.value}
                    pill
                    onClick={() =>
                        setSelectedEle(selectedEle.filter((f) => f !== ele))
                    }
                    style={{ cursor: 'pointer', backgroundColor: '#FF8C00' }}
                >
                    {type === "month" ? <>{dayjs(ele.value).format("MMMM")}<span className="ms-1">×</span></> :
                        <>{ele.value}<span className="ms-1">×</span></>}
                </Badge>
            ))
        }
    </>
    )
}